import {useEffect, useState} from "react";
import './guideIOS.css'
import React from 'react';
import UtilBrowser from "@/Master/UtilBrowser";
import {confJson} from "@/app/config/confJson";

export default function GuideIOS({onCloseGuide}:any) {
    const [overlayShow, setOverlayShow] = useState(false)
    const [safariDialogShow, setSafariDialogShow] = useState(false)
    const [guideDialogShow, setGuideDialogShow] = useState(false)

    const [currentUrl, setCurrentUrl] = useState('')

    function closeSafariDialog() {
        setSafariDialogShow(false)
        setGuideDialogShow(false)
        setOverlayShow(false)
        onCloseGuide()
    }

    function closeGuideDialog() {
        setGuideDialogShow(false)
        setSafariDialogShow(false)
        setOverlayShow(false)
        onCloseGuide()
    }

    function showGuideDialog() {
        setGuideDialogShow(true)
        setOverlayShow(true)
    }

    function showSafariDialog() {
        setSafariDialogShow(true)
        setOverlayShow(true)
    }

    useEffect(() => {
        setCurrentUrl(window.location.href);
        if (UtilBrowser.isFacebookApp) {
            showSafariDialog()
        } else {
            showGuideDialog()
        }

    }, []);

    return (
        <div className="guide-pop">
            {overlayShow && <div id="overlay" className="overlay"></div>}
            {safariDialogShow && <div id="safariDialog" className="ios-dialog guide-show">
                <div className="dialog-content">
                    <div className="div-info">
                        <img className="img-icon" src={'/logo.webp'} alt="logo"/>
                        <div className="description">We would like to add it to your home screen for the latest free
                            bets and
                            bonus updates.
                        </div>
                    </div>
                    <div className="line"></div>
                    <div className="div-action">
                        {/*<div className="btn-app" style={displayNone}>*/}
                        {/*    <div className="tips">Enjoy more benefits!</div>*/}
                        {/*    <img src={require('../../../../assets/landPageAssets/images/icon-apple-White.png')} alt="icon-apple-White"/>*/}
                        {/*    <div className="text">APP</div>*/}
                        {/*</div>*/}
                        <div id="btnWebApp" className="btn-app plain" onClick={showGuideDialog}>
                            <img src={'/img/guideIOS/icon-apple-White.png'}
                                 alt="icon-apple-White"/>
                            <div className="text">WEB-APP</div>
                        </div>
                    </div>
                    <div id="btnH5" className="div-use-h5" onClick={closeSafariDialog}>Continue to use H5</div>
                </div>
                <div id="closeDialogBtnSafari" className="div-closeBtn" onClick={closeSafariDialog}></div>
            </div>}
            {guideDialogShow && <div id="guideDialog" className="guide-dialog guide-show" onClick={closeGuideDialog}>
                <div id="closeBtnIosGuide" className="close-btn"></div>
                <div className="title">
                    Add to Home Screen
                </div>
                <div className="guide-content">
                    <div>1.Click on the button to open the menu,
                        open in external browser.
                    </div>
                    <div className="step1">
                        <div className="name">{confJson.h5_app_name}</div>
                        <img className="icon-lock" src={'/img/guideIOS/lock.png'}
                             alt="lock"/>
                        <div className="url">
                            <span>{currentUrl}</span>
                        </div>
                        <img className="background" src={'/img/guideIOS/Tutorial_0.webp'}
                             alt="Tutorial_0"/>
                    </div>
                    <div>2. Tap the Share icon at the bottom of the
                        screen.
                    </div>
                    <div className="step1">
                        <img className="background" src={'/img/guideIOS/Tutorial_1.webp'}
                             alt="Tutorial_1"/>
                    </div>
                    <div>3. Scroll down to the list of actions and tap
                        Add to Home Screen.
                    </div>
                    <div className="step1">
                        <img className="background" src={'/img/guideIOS/Tutorial_2.webp'}
                             alt="Tutorial_2"/>
                    </div>
                    <div>4. Click to add，select “Add”</div>
                    <div className="step3">
                        <img className="icon logo" src={'/logo.webp'} alt="logo"/>
                        <div className="name">{confJson.h5_app_name}</div>
                        <div className="url">{currentUrl}</div>
                        <img className="background" src={'/img/guideIOS/Tutorial_3.webp'}
                             alt="Tutorial_3"/>
                    </div>
                </div>
            </div>}
        </div>

    )
}
